<div class="mainBody">
    <div class="dmv-search-results inner-home">
        <div class="container">
            <div class="row no-margin">
                <div class="col-6 col-sm-2 mt-4 "><a><button  (click)="back()" class="btn btn-primary btn-back top-back-button"><i
                    class="fa fa-chevron-left text-left"></i> Back</button></a></div>
                

                <div class="col-12 col-sm-8 mt-4">
                    <div id="searchResu">Enrollment FAQs</div>
                    <p id="addthereco">&nbsp;</p>
                </div>
                <div class="col-6 col-sm-2 icon-cart mt-4">

                </div>
             
           
               
                   
                  
                        <div class="container mt-2 mb-5" [innerHTML]="(megStoreService.configurationsData$ | async)?.megConfig?.accountFAQsText">
                            <!-- <div class="faqHd mt-4 mb-2">What are the benefits of having a MyEasyGov account?</div>
                            <div class="faqAnswer mb-2">Simplify the payment process by keeping your billing information, credit/debit cards and bank accounts in your profile. Once set up, you will need to type in the data again when you make payment
                                <br/>
                                <br/>
                                In some cases, MyEasyGov will remind you when your bills are upcoming.
                            </div>

                            <div class="faqHd mt-4 mb-2">Is the account free?</div>
                            <div class="faqAnswer mb-2">Yes
                            </div>

                            <div class="faqHd mt-4 mb-2">Are cards and bank account stored securely?</div>
                            <div class="faqAnswer mb-2">Cards and bank account accounts are stored securely in accordance with industry best pretties, I.e. PCI compliance, by your Tax Collector’s service vendor
                            </div> -->

                       </div>
                       
                

                   
              
            </div>

            <div class="container m-auto text-center">
                            <a><button
                        class="btn btn-primary  btn-continue m-auto" (click)="back()">Close</button></a></div>
        </div>
    </div>
</div>